/* capkov-rd (3. 10.): jeden znovupoužitelný panel pro informační stránky a kontaktní formulář.
   - klik na odkaz na informační stránku (/pages/doprava-a-platba, /policies/…) nebo na mailto: otevře panel na stejné stránce
     (na mobilu spodní list, na desktopu boční panel), zákazník neopustí produkt
   - obsah: fetch stránky, vytažení hlavního obsahu (#main bez patičky), cache v paměti i v sessionStorage, doběh chybějících CSS
   - přístupnost: nativní <dialog> (modal), focus trap, Esc, návrat fokusu, tlačítko Zpět v prohlížeči zavře panel (history.pushState)
   - vždy je vidět „Otevřít celou stránku“
   - kontaktní formulář (jméno, e-mail, číslo objednávky, zpráva, volitelně fotka) místo mailto: odesílá do Gatherinu (formulář capkov-kontakt; honeypot + časová past + limity řeší Gatherino, bez captchy)
   Ruční vyvolání: window.rdDrawer.open('/pages/x'), window.rdDrawer.contact({tema:'reklamace', message:'…'});
   atributy: data-rd-drawer (vynutit; ="off" nikdy), data-rd-contact (otevřít formulář), data-tema, data-subject. */
(function () {
  'use strict';
  if (window.rdDrawer) return;

  var CONF = {
    /* GATHERINO: odpovědi z kontaktního formuláře hostuje Gatherino (multipart). Při přechodu na ostrou měnit JEN hosta:
       gatherino.com -> gatherino.com (jediné místo v tomto souboru). */
    endpoint: 'https://gatherino.com/api/embed/forms/capkov-kontakt/submit',
    /* pole „Fotka“ ve formuláři (Gatherino ji přijme: až 3 soubory, dohromady 5 MB). Zapnout až po schválení vzhledu. */
    photos: false,
    instagram: 'https://www.instagram.com/capkov_prague/',
    mail: 'info@capkov.cz',
    get privacy() { return RU('/pages/zasady-ochrany-osobnich-udaju'); },
    minMs: 3200
  };

  /* ------------------------------------------------------------ pravidla odkazů ---- */
  var INFO_PAGES = [
    'doprava-a-platba', 'reklamace-a-vraceni', 'vraceni-zbozi', 'popis-produktu',
    'faq-nejcastejsi-dotazy-k-cepicim-doprave-a-platbe-capkov-cz', 'cepicovy-slovnik',
    'zasady-ochrany-osobnich-udaju',
    /* 'pro-firmy-a-tymy' záměrně NE: formulář stránky (capkov-rd-b2b-form.js) se v panelu neinicializoval (odeslání spadlo na nativní submit), B2B se otevírá normálně */
    'jak-vysivame-v-cr-kvalitni-vysivka-na-cepice-capkov-cz',
    'cepice-na-miru-od-overeneho-vyrobce-etika-certifikace-capkov-cz',
    'cepice-s-vysivkou-na-miru-vlastni-text-monogram-i-motiv-capkov-cz'
  ];
  var CONTACT_PAGES = ['kontaktujte-nas-capkov-cz', 'zeptat-se'];
  /* typy stránek, kde se odkazy v obsahu otevírají v panelu (jinde jen mailto, odkazy s data-rd-drawer a odkazy v košíku) */
  var SCOPE_TYPES = ['product', 'collection', 'cart', 'search'];

  function pageType() { return document.body ? document.body.getAttribute('data-rd-t') || '' : ''; }
  function norm(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      if (u.origin !== location.origin) return null;
      var p = u.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/(pages|policies)\/)/i, '').replace(/\/+$/, '');
      return { path: p, url: u, key: p };
    } catch (e) { return null; }
  }
  function classify(a) {
    if (!a || !a.getAttribute) return null;
    var h = a.getAttribute('href') || '';
    if (a.getAttribute('data-rd-drawer') === 'off' || a.hasAttribute('data-rd-nodrawer')) return null;
    if (/^mailto:/i.test(h)) return { kind: 'contact', mailto: h };
    if (a.hasAttribute('data-rd-contact')) return { kind: 'contact' };
    var n = norm(a); if (!n) return null;
    var m = n.path.match(/^\/(pages|policies)\/([^/]+)/);
    var forced = a.hasAttribute('data-rd-drawer');
    if (!m) return null;
    var isInfo = m[1] === 'policies' || INFO_PAGES.indexOf(m[2]) > -1;
    var isContact = m[1] === 'pages' && CONTACT_PAGES.indexOf(m[2]) > -1;
    if (!isInfo && !isContact && !forced) return null;
    if (!forced) {
      var inCart = a.closest && a.closest('cart-drawer, #cart-drawer, [id*="cart-drawer"], .rdc-bar, .cart-drawer, [class*="rdc-"]');
      var inChrome = a.closest && a.closest('header, footer, [class*="footer"], [class*="header__"], .rd-bar, nav[aria-label*="hlavní"], nav[aria-label*="Main"], .rdd');
      if (inChrome && !inCart) return null;
      if (SCOPE_TYPES.indexOf(pageType()) < 0 && !inCart) return null;
      if (inCart && !a.closest('.rdd') && false) return null;
    }
    if (isContact) return { kind: 'contact' };
    return { kind: 'page', url: n.url.pathname + n.url.search };
  }

  /* ------------------------------------------------------------ načtení obsahu ---- */
  var cache = {}, SS = 'rdd:v3:';
  function ssGet(k) { try { return sessionStorage.getItem(SS + k); } catch (e) { return null; } }
  function ssSet(k, v) { try { if (v.length < 400000) sessionStorage.setItem(SS + k, v); } catch (e) { } }
  function hasSheet(href) {
    var p = href.split('?')[0], L = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < L.length; i++) if ((L[i].getAttribute('href') || '').split('?')[0] === p) return true;
    return false;
  }
  function extract(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var secs = [].slice.call(d.querySelectorAll('#main > .shopify-section')).filter(function (s) {
      return !/footer|announcement|header/i.test(s.className + ' ' + s.id);
    });
    var host = d.createElement('div');
    if (secs.length) secs.forEach(function (s) { host.appendChild(s); });
    else { var m = d.querySelector('#main, main, .shopify-policy__container, body'); if (m) host.innerHTML = m.innerHTML; }
    [].forEach.call(host.querySelectorAll('.shopify-section-group-header-group,.shopify-section-group-footer-group,[id*="__header"],[id*="__footer"],[id*="announcement"]'), function (n) { n.remove(); });
    var h1 = host.querySelector('h1');
    var title = (h1 && h1.textContent.trim()) || (d.title || '').split(/[–|\-]\s*(?=[^–|\-]*$)/)[0].trim();
    var css = [].slice.call(d.head.querySelectorAll('link[rel="stylesheet"][href]')).map(function (l) { return l.getAttribute('href'); });
    return { title: title, html: host.innerHTML, css: css };
  }
  function load(url) {
    if (cache[url]) return cache[url];
    var s = ssGet(url);
    if (s) { try { return (cache[url] = Promise.resolve(JSON.parse(s))); } catch (e) { } }
    cache[url] = fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'rd-drawer' } }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.text();
    }).then(function (t) {
      var x = extract(t); if (!x.html || x.html.replace(/\s/g, '').length < 40) throw new Error('prazdno');
      ssSet(url, JSON.stringify(x)); return x;
    });
    cache[url].catch(function () { delete cache[url]; });
    return cache[url];
  }

  /* ------------------------------------------------------------ panel ---- */
  var dlg, bodyEl, titleEl, fullEl, backEl, sheet, opener = null, stack = [], panels = {}, pushed = false, formOpenedAt = 0;

  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'rdd'; dlg.setAttribute('aria-labelledby', 'rdd-t');
    dlg.innerHTML =
      '<div class="rdd__sheet" tabindex="-1">' +
      '<span class="rdd__grab" aria-hidden="true"></span>' +
      '<header class="rdd__bar">' +
      '<button type="button" class="rdd__back" aria-label="' + esc(RT('cart.dr_back', 'Zpět')) + '" hidden><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<h2 class="rdd__title" id="rdd-t"></h2>' +
      '<button type="button" class="rdd__x" aria-label="' + esc(RT('cart.dr_close', 'Zavřít')) + '"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '</header>' +
      '<div class="rdd__body" data-rdd-body></div>' +
      '<footer class="rdd__foot"><a class="rdd__full" href="#" hidden>' + RT('cart.dr_full_html', 'Otevřít celou stránku <span aria-hidden="true">↗</span>') + '</a><button type="button" class="rdd__cta" data-rdd-cta hidden></button></footer>' +
      '</div>';
    document.body.appendChild(dlg);
    sheet = dlg.querySelector('.rdd__sheet'); bodyEl = dlg.querySelector('[data-rdd-body]');
    titleEl = dlg.querySelector('.rdd__title'); fullEl = dlg.querySelector('.rdd__full'); backEl = dlg.querySelector('.rdd__back');
    dlg.querySelector('.rdd__x').addEventListener('click', close);
    backEl.addEventListener('click', function () { if (stack.length > 1) { stack.pop(); show(stack[stack.length - 1]); } });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', trap);
    /* Esc zavře jen panel (ne košík pod ním): zachytit dřív než posluchač košíku */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && dlg.open) { e.preventDefault(); e.stopImmediatePropagation(); close(); }
    }, true);
    /* tažení spodního listu dolů (mobil) */
    var y0 = null, dy = 0;
    sheet.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.rdd__grab, .rdd__bar')) return; y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none';
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
    sheet.addEventListener('touchend', function () {
      if (y0 === null) return; sheet.style.transition = ''; sheet.style.transform = ''; var go = dy > 90; y0 = null; dy = 0; if (go) close();
    });
    window.addEventListener('popstate', function () {
      if (dlg.open && !(history.state && history.state.rdd)) { pushed = false; hide(); }
    });
    bodyEl.addEventListener('click', onBodyClick);
  }
  function focusables() {
    return [].slice.call(dlg.querySelectorAll('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"]),summary')).filter(function (e) {
      return !e.disabled && !e.hidden && e.offsetParent !== null && !e.closest('[hidden]');
    });
  }
  function trap(e) {
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) { e.preventDefault(); return; }
    var a = document.activeElement, first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (a === first || a === sheet)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  function hide() {
    if (!dlg || !dlg.open) return;
    dlg.classList.remove('rdd--in');
    var done = function () { stack = []; try { dlg.close(); } catch (e) { } document.documentElement.classList.remove('rdd-lock'); if (opener && opener.focus && document.contains(opener)) try { opener.focus({ preventScroll: true }); } catch (e) { } };
    setTimeout(done, matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 220);
  }
  function close() {
    if (!dlg || !dlg.open) return;
    if (pushed && history.state && history.state.rdd) { history.back(); } else { pushed = false; hide(); }
  }
  function openShell(opener_) {
    build();
    if (!dlg.open) {
      opener = opener_ || document.activeElement;
      stack = [];
      /* panel z košíku: zavřít nepotřebujeme, nativní dialog je v top layer nad ním */
      dlg.showModal(); document.documentElement.classList.add('rdd-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('rdd--in'); }); });
      if (!pushed) { try { history.pushState({ rdd: 1 }, '', location.href); pushed = true; } catch (e) { } }
    }
  }
  function show(entry) {
    [].forEach.call(bodyEl.children, function (c) { c.hidden = c !== entry.panel; });
    titleEl.textContent = entry.title || '';
    backEl.hidden = stack.length < 2;
    if (entry.full) { fullEl.href = entry.full; fullEl.hidden = false; } else fullEl.hidden = true;
    var cta = dlg.querySelector('[data-rdd-cta]');
    if (cta) { cta.hidden = !entry.full; cta.textContent = entry.ctaLabel || CTA_DEFAULT; cta.onclick = function () { openContact({ tema: entry.tema || '' }, opener); }; }
    bodyEl.scrollTop = 0;
    var t = entry.focus ? entry.panel.querySelector(entry.focus) : null;
    if (t) setTimeout(function () { try { t.focus({ preventScroll: true }); } catch (e) { } }, 60); else try { sheet.focus({ preventScroll: true }); } catch (e) { }
  }
  function push(entry) {
    stack.push(entry); show(entry);
  }

  /* ------------------------------------------------------------ stránky ---- */
  function rerunScripts(root) {
    [].slice.call(root.querySelectorAll('script')).forEach(function (o) {
      if (o.type && !/javascript|module/.test(o.type)) return;
      if (o.src && document.querySelector('script[src="' + o.getAttribute('src') + '"]')) { o.remove(); return; }
      var n = document.createElement('script');
      [].forEach.call(o.attributes, function (a) { n.setAttribute(a.name, a.value); });
      n.text = o.text; o.parentNode.replaceChild(n, o);
    });
  }
  function openPage(url, from) {
    openShell(from);
    var key = 'p:' + url;
    if (panels[key]) { var ex = stack.filter(function (s) { return s.key === key; })[0]; if (ex) { stack = stack.slice(0, stack.indexOf(ex) + 1); show(ex); return; } }
    var panel = panels[key] || document.createElement('section');
    if (!panels[key]) {
      panel.className = 'rdd__panel'; panel.hidden = true; panel.innerHTML = '<div class="rdd__load" role="status"><i></i><i></i><i></i><span class="rdd-sr">' + esc(RT('cart.dr_loading', 'Načítám…')) + '</span></div>'; bodyEl.appendChild(panel); panels[key] = panel;
    }
    var entry = { key: key, panel: panel, title: '', full: url };
    push(entry);
    if (panel.getAttribute('data-ready')) { entry.title = panel.getAttribute('data-title'); titleEl.textContent = entry.title; return; }
    load(url).then(function (x) {
      x.css.forEach(function (h) {
        if (!hasSheet(h)) { var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = h; document.head.appendChild(l); }
      });
      panel.innerHTML = '<div class="rdd__content rdd__content--page">' + x.html + '</div>';
      [].forEach.call(panel.querySelectorAll('img:not([loading])'), function (im) { im.loading = 'lazy'; im.decoding = 'async'; });
      rerunScripts(panel);
      panel.setAttribute('data-ready', '1'); panel.setAttribute('data-title', x.title);
      entry.title = x.title; if (stack[stack.length - 1] === entry) { titleEl.textContent = x.title; bodyEl.scrollTop = 0; }
    }).catch(function () {
      panel.innerHTML = '<div class="rdd__content"><p class="rdd__err">' + esc(RT('cart.dr_loaderr', 'Stránku se nepodařilo načíst do panelu.')) + '</p><p><a class="rdd__btn" href="' + url + '">' + esc(RT('cart.dr_full', 'Otevřít celou stránku')) + '</a></p></div>';
      entry.title = RT('cart.dr_loaderr_t', 'Nepodařilo se načíst');
      if (stack[stack.length - 1] === entry) titleEl.textContent = entry.title;
    });
  }

  /* vlastní obsah (např. „Jak to probíhá“): rdDrawer.openNode(titulek, element) */
  var CTA_DEFAULT = RT('cart.dr_cta', 'Napsat nám');
  var nodeSeq = 0;
  function openNode(title, node, from, opts) {
    opts = opts || {};
    openShell(from);
    var key = 'n:' + (nodeSeq++), panel = document.createElement('section');
    panel.className = 'rdd__panel'; panel.hidden = true; var w = document.createElement('div'); w.className = 'rdd__content rdd__how'; w.appendChild(node); panel.appendChild(w);
    bodyEl.appendChild(panel); panels[key] = panel;
    stack = stack.filter(function (s) { if (s.key.indexOf('n:') === 0) { s.panel.remove(); delete panels[s.key]; return false; } return true; });
    push({ key: key, panel: panel, title: title, full: opts.full || null, ctaLabel: opts.cta || '', tema: opts.tema || '' });
  }

  /* ------------------------------------------------------------ formulář ---- */
  /* TEMA_CS = české štítky, které se posílají do Gatherina (backend zůstává česky); TEMA = to, co vidí zákazník */
  var TEMA_CS = [['', 'Vyber (nepovinné)'], ['objednavka', 'Dotaz k objednávce'], ['doruceni', 'Doručení'], ['vraceni', 'Vratky'], ['reklamace', 'Reklamace'], ['produkt', 'Dotaz k produktu'], ['vlastni-design', 'Vlastní design'], ['jine', 'Něco jiného']];
  var TEMA = [['', RT('cart.dr_t_none', 'Vyber (nepovinné)')], ['objednavka', RT('cart.dr_t_objednavka', 'Dotaz k objednávce')], ['doruceni', RT('cart.dr_t_doruceni', 'Doručení')], ['vraceni', RT('cart.dr_t_vraceni', 'Vratky')], ['reklamace', RT('cart.dr_t_reklamace', 'Reklamace')], ['produkt', RT('cart.dr_t_produkt', 'Dotaz k produktu')], ['vlastni-design', RT('cart.dr_t_vlastni', 'Vlastní design')], ['jine', RT('cart.dr_t_jine', 'Něco jiného')]];
  function F(s) { for (var i = 1; i < arguments.length; i++) { (function (v) { s = s.replace('{' + (i - 1) + '}', function () { return v; }); })(arguments[i]); } return s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pageCtx() {
    var M = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product, h1 = document.querySelector('h1');
    var prod = (M && M.variants && M.variants[0] && M.variants[0].name) || (pageType() === 'product' && h1 ? h1.textContent.trim() : '');
    return { produkt: String(prod || '').slice(0, 120), url: location.href.replace(/[?&](rd_text|rd_thread|rd_open)=[^&]*/g, '').slice(0, 500), varianta: new URLSearchParams(location.search).get('variant') || '', stranka: (document.title || '').slice(0, 200) };
  }
  function formHtml(o, id) {
    var useZ = !!CONF.photos;
    var sel = TEMA.map(function (t) { return '<option value="' + t[0] + '"' + (o.tema === t[0] ? ' selected' : '') + '>' + t[1] + '</option>'; }).join('');
    return '<div class="rdd__content rdd__content--form">' +
      '<p class="rdd__lead">' + esc(o.lead || RT('cart.dr_lead', 'Napiš nám, odpovíme ti e-mailem. Nemusíš nikam přepínat do pošty.')) + '</p>' +
      '<form class="rdf" novalidate data-rdf>' +
      '<label class="rdf__l" for="' + id + '-t">' + esc(RT('cart.dr_topic', 'Téma')) + '</label><select class="rdf__in" id="' + id + '-t" name="tema">' + sel + '</select>' +
      '<label class="rdf__l" for="' + id + '-n">' + esc(RT('cart.dr_name', 'Jméno')) + '</label><input class="rdf__in" id="' + id + '-n" name="jmeno" type="text" autocomplete="name" maxlength="100" required>' +
      '<label class="rdf__l" for="' + id + '-e">' + esc(RT('cart.dr_email', 'E-mail')) + '</label><input class="rdf__in" id="' + id + '-e" name="email" type="email" autocomplete="email" inputmode="email" maxlength="200" required placeholder="' + esc(RT('cart.dr_email_ph', 'tvuj@email.cz')) + '">' +
      '<label class="rdf__l" for="' + id + '-o">' + esc(RT('cart.dr_order', 'Číslo objednávky')) + ' <span>' + esc(RT('cart.dr_optional', '(nepovinné)')) + '</span></label><input class="rdf__in" id="' + id + '-o" name="objednavka" type="text" maxlength="40" autocomplete="off" placeholder="' + esc(RT('cart.dr_order_ph', 'Najdeš ho v potvrzení objednávky')) + '">' +
      '<label class="rdf__l" for="' + id + '-m">' + esc(RT('cart.dr_msg', 'Zpráva')) + '</label><textarea class="rdf__in" id="' + id + '-m" name="zprava" rows="5" maxlength="2800" required></textarea>' +
      (useZ ? '<label class="rdf__l" for="' + id + '-f">' + esc(RT('cart.dr_photo', 'Fotka')) + ' <span>' + esc(RT('cart.dr_photo_hint', '(nepovinné, až 3 soubory, dohromady 5 MB)')) + '</span></label><input class="rdf__in rdf__file" id="' + id + '-f" name="foto" type="file" accept="image/png,image/jpeg,image/webp" multiple>' : '') +
      '<div class="rdf__hp" aria-hidden="true"><input type="text" name="hp" tabindex="-1" autocomplete="off" aria-hidden="true" inert></div>' +
      '<p class="rdf__err" role="alert" hidden data-rdf-err></p>' +
      '<button type="submit" class="rdd__btn rdd__btn--main" data-rdf-go>' + esc(RT('cart.dr_send', 'Odeslat zprávu')) + '</button>' +
      '<p class="rdf__gdpr">' + esc(RT('cart.dr_gdpr', 'Odesláním souhlasíš se zpracováním osobních údajů za účelem odpovědi na tvůj dotaz.')) + ' <a href="' + CONF.privacy + '" data-rd-drawer>' + esc(RT('cart.dr_privacy', 'Zásady ochrany osobních údajů')) + '</a>.</p>' +
      '</form>' +
      '<p class="rdf__alt">' + esc(RT('cart.dr_alt', 'Radši rychle na sítích?')) + ' <a href="' + CONF.instagram + '" target="_blank" rel="noopener">' + esc(RT('cart.dr_insta', 'Napiš nám na Instagram @capkov_prague')) + '</a>.</p>' +
      '</div>' +
      '<div class="rdd__content rdf__ok" hidden role="status" data-rdf-ok></div>';
  }
  function bindForm(panel, o) {
    var form = panel.querySelector('[data-rdf]'), err = panel.querySelector('[data-rdf-err]'), go = panel.querySelector('[data-rdf-go]'), ok = panel.querySelector('[data-rdf-ok]');
    var f = form.elements, sending = false;
    if (o.message) f.zprava.value = o.message;
    function fail(m) { err.textContent = m; err.hidden = false; go.disabled = false; go.textContent = RT('cart.dr_send', 'Odeslat zprávu'); sending = false; }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (sending) return; err.hidden = true;
      var jm = f.jmeno.value.trim(), em = f.email.value.trim(), ms = f.zprava.value.trim(), ob = f.objednavka.value.trim(), tema = f.tema.value;
      if (!jm) { fail(RT('cart.dr_e_name', 'Napiš nám prosím své jméno.')); f.jmeno.focus(); return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(em)) { fail(RT('cart.dr_e_email', 'Zadej prosím platný e-mail.')); f.email.focus(); return; }
      if (ms.length < 5) { fail(RT('cart.dr_e_msg', 'Napiš nám prosím zprávu (aspoň pár slov).')); f.zprava.focus(); return; }
      if (ob && !/^[\w#\- ]{1,40}$/.test(ob)) { fail(RT('cart.dr_e_order', 'Číslo objednávky může obsahovat jen písmena, číslice, # a pomlčku.')); f.objednavka.focus(); return; }
      var files = f.foto && f.foto.files ? [].slice.call(f.foto.files) : [];
      if (files.length > 3) { fail(RT('cart.dr_e_files', 'Nahraj prosím nejvýše 3 fotky.')); return; }
      if (files.reduce(function (s, x) { return s + x.size; }, 0) > 5 * 1024 * 1024) { fail(RT('cart.dr_e_size', 'Fotky jsou dohromady větší než 5 MB.')); return; }
      sending = true; go.disabled = true; go.textContent = RT('cart.dr_sending', 'Odesílám…');
      var ctx = pageCtx(), temaLabel = (TEMA_CS.filter(function (t) { return t[0] === tema; })[0] || [])[1] || '';
      var wait = Math.max(0, CONF.minMs - (Date.now() - formOpenedAt));
      setTimeout(function () {
        var t = Date.now() - formOpenedAt, req;
        var fd = new FormData();
        fd.append('jmeno', jm); fd.append('email', em); fd.append('objednavka', ob); fd.append('tema', temaLabel); fd.append('zprava', ms);
        fd.append('kontext_produkt', ctx.produkt); fd.append('kontext_url', ctx.url); fd.append('kontext_varianta', ctx.varianta); fd.append('kontext_stranka', ctx.stranka); fd.append('kontext_shop', location.hostname);
        fd.append('locale', ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'cs').slice(0, 5));
        fd.append('hp', f.hp.value); fd.append('t', String(t)); files.forEach(function (x) { fd.append('foto', x, x.name); });
        req = { url: CONF.endpoint, init: { method: 'POST', body: fd, credentials: 'omit' } };
        var ctl = window.AbortController ? new AbortController() : null, to = setTimeout(function () { if (ctl) ctl.abort(); }, 45000);
        if (ctl) req.init.signal = ctl.signal;
        fetch(req.url, req.init).then(function (r) {
          clearTimeout(to);
          if (r.status === 200) {
            panel.querySelector('.rdd__content--form').hidden = true; ok.hidden = false;
            ok.innerHTML = '<svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M8 12.5l3 3 5-6"/></svg><h3>' + esc(RT('cart.dr_ok_t', 'Zpráva je odeslaná')) + '</h3><p>' + F(esc(RT('cart.dr_ok_p', 'Díky, {0}. Odpověď ti pošleme e-mailem na {1}.')), esc(jm), esc(em)) + '</p>' + (panel.hasAttribute('data-rd-inline') ? '' : '<button type="button" class="rdd__btn rdd__btn--main" data-rdd-close>' + esc(RT('cart.dr_close', 'Zavřít')) + '</button>') + '';
            form.reset(); var b = ok.querySelector('button'); if (b) b.focus();
            return;
          }
          return r.json().catch(function () { return {}; }).then(function (j) {
            fail(j.error || (r.status === 429 ? RT('cart.dr_e_429', 'Příliš mnoho zpráv v krátké době. Zkus to prosím později.') : F(RT('cart.dr_e_send', 'Odeslání se nepodařilo. Zkus to prosím za chvíli, nebo nám napiš na {0}.'), CONF.mail)));
          });
        }).catch(function () { clearTimeout(to); fail(F(RT('cart.dr_e_net', 'Spojení se nepodařilo. Zkus to prosím za chvíli, nebo nám napiš na {0}.'), CONF.mail)); });
      }, wait);
    });
  }
  var formSeq = 0;
  function openContact(o, from) {
    o = o || {};
    openShell(from);
    var key = 'c:' + (formSeq++), panel = document.createElement('section');
    panel.className = 'rdd__panel'; panel.hidden = true; panel.innerHTML = formHtml(o, 'rdf' + formSeq); bodyEl.appendChild(panel); panels[key] = panel;
    /* nový formulář vždy znovu (nezůstanou stará vyplněná pole z jiného dotazu); starý panel se uklidí */
    stack = stack.filter(function (s) { if (s.key.indexOf('c:') === 0) { s.panel.remove(); delete panels[s.key]; return false; } return true; });
    formOpenedAt = Date.now(); bindForm(panel, o);
    push({ key: key, panel: panel, title: o.title || RT('cart.dr_write', 'Napiš nám'), full: null, focus: o.message ? '[name=jmeno]' : '[name=jmeno]' });
  }
  function fromMailto(h) {
    var o = {}, q = (h.split('?')[1] || '');
    try { var p = new URLSearchParams(q); if (p.get('subject')) o.message = p.get('subject') + (p.get('body') ? '\n\n' + p.get('body') : '') + '\n'; else if (p.get('body')) o.message = p.get('body'); } catch (e) { }
    return o;
  }

  /* vložený formulář (snippet capkov-rd-contact-form): <div data-rd-contact-inline data-context="dilna|pdp|faq"> */
  var CTX_TEMA = { pdp: 'produkt', dilna: 'vlastni-design', faq: 'jine', doruceni: 'doruceni', reklamace: 'reklamace' };
  function mountInline(el) {
    if (el.getAttribute('data-rd-mounted')) return; el.setAttribute('data-rd-mounted', '1');
    var c = el.getAttribute('data-context') || '', o = { tema: CTX_TEMA[c] || '', lead: el.getAttribute('data-lead') || '' };
    var box = document.createElement('div'); box.setAttribute('data-rd-inline', c || '1'); box.className = 'rdd__inline';
    box.innerHTML = formHtml(o, 'rdi' + (formSeq++)); var ns = el.querySelector('noscript'); if (ns) ns.remove();
    el.appendChild(box); formOpenedAt = formOpenedAt || Date.now(); bindForm(box, o);
    var fo = box.querySelector('[data-rdf]'); fo.addEventListener('focusin', function () { formOpenedAt = Math.min(formOpenedAt, Date.now() - 0); }, { once: true });
  }
  function mountAll() { [].forEach.call(document.querySelectorAll('[data-rd-contact-inline]'), mountInline); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
  if (window.MutationObserver) new MutationObserver(function () { if (document.querySelector('[data-rd-contact-inline]:not([data-rd-mounted])')) mountAll(); }).observe(document.documentElement, { childList: true, subtree: true });

  /* ------------------------------------------------------------ události ---- */
  function onBodyClick(e) {
    var c = e.target.closest && e.target.closest('[data-rdd-close]'); if (c) { close(); return; }
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href');
    if (h.charAt(0) === '#' && h.length > 1) {
      var t = null; try { t = bodyEl.querySelector('[id="' + h.slice(1).replace(/"/g, '') + '"]'); } catch (x) { }
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var r = classifyLoose(a); if (!r) { if (!a.target && a.origin === location.origin) { /* jiný odkaz webu: zavřít panel a přejít */ closeNow(); } return; }
    e.preventDefault();
    if (r.kind === 'contact') openContact(r.mailto ? fromMailto(r.mailto) : {}, opener); else openPage(r.url, opener);
  }
  function closeNow() { if (pushed) { pushed = false; try { history.back(); } catch (e) { } } }
  /* uvnitř panelu platí odkazy bez omezení na typ stránky */
  function classifyLoose(a) {
    var h = a.getAttribute('href') || '';
    if (/^mailto:/i.test(h)) return { kind: 'contact', mailto: h };
    if (a.hasAttribute('data-rd-contact')) return { kind: 'contact' };
    var n = norm(a); if (!n) return null;
    var m = n.path.match(/^\/(pages|policies)\/([^/]+)/); if (!m) return null;
    if (m[1] === 'pages' && CONTACT_PAGES.indexOf(m[2]) > -1) return { kind: 'contact' };
    if (m[1] === 'policies' || INFO_PAGES.indexOf(m[2]) > -1 || a.hasAttribute('data-rd-drawer')) return { kind: 'page', url: n.url.pathname + n.url.search };
    return null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href], [data-rd-contact]'); if (!a) return;
    if (a.closest && a.closest('.rdd')) return;
    if (a.closest && a.closest('[data-rd-consult]')) return; /* „Poradit s návrhem“ otevírá vlastní popup (capkov-rd-consult.js), ne obecný panel – jinak se otevřou oba */
    if (a.tagName !== 'A') { e.preventDefault(); openContact({ tema: a.getAttribute('data-tema') || '', message: a.getAttribute('data-message') || '' }, a); return; }
    var r = classify(a); if (!r) return;
    e.preventDefault();
    if (r.kind === 'contact') openContact(r.mailto ? fromMailto(r.mailto) : { tema: a.getAttribute('data-tema') || '' }, a); else openPage(r.url, a);
  });
  /* předběžné načtení při najetí / dotyku */
  function warm(e) {
    var a = e.target.closest && e.target.closest('a[href]'); if (!a || (a.closest && a.closest('.rdd'))) return;
    var r = classify(a); if (r && r.kind === 'page') load(r.url).catch(function () { });
  }
  document.addEventListener('pointerenter', warm, true);
  document.addEventListener('touchstart', warm, { passive: true, capture: true });

  window.rdDrawer = { openNode: openNode, mountInline: mountAll, open: function (u, from) { openPage(u, from); }, contact: function (o, from) { openContact(o, from); }, close: close, config: CONF };
})();
